<template>
  <NuxtLink :to="`/${service.slug}`" class="block w-full min-w-0">
    <Commerce-Card clickable class="flex flex-col gap-4 p-5 ">
      <div class="flex items-start gap-3">
        <Commerce-ServiceGlyph :glyph="getServiceTypeGlyph(service.service_type?.slug ?? 'other')" :src="logoUrl"
          :alt="service.name" size="sm" />
        <div class="min-w-0">
          <div class="flex items-center gap-2">
            <h3 class="truncate font-bold">{{ service.name }}</h3>
            <span v-if="service.isFeatured" class="text-accent text-xs">★</span>
          </div>
          <p class="text-xs text-muted-foreground">{{ service.provider?.name }}</p>
        </div>
      </div>
      <p class="line-clamp-2 text-sm leading-relaxed text-muted-foreground">{{ service?.shortDescription }}</p>
      <div class="mt-auto flex items-center justify-between border-t border-border pt-3">
        <div class="text-sm">
          <span class="text-muted-foreground">شروع از </span>
          <span class="font-bold text-accent nums">
            {{ service.start_from
              ? fx(Number(service.start_from), getCurrency(service.currency?.code))
              : '-'
            }}
          </span>
        </div>
        <span class="text-sm font-semibold text-primary">مشاهده و سفارش ›</span>
      </div>
    </Commerce-Card>
  </NuxtLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Service } from '~/api/typings'
import { fx } from '~/utils/format'
import { getServiceTypeGlyph } from '~/utils/service-glyphs'

const props = defineProps<{ service: Service }>()

const resolveStorageUrl = useStorageUrl()

const logoUrl = computed(() => resolveStorageUrl(props.service.logo_url ?? props.service.provider?.logo_url ?? null))

const getCurrency = (currency?: string | null): 'USD' | 'EUR' => {
  return currency === 'EUR' ? 'EUR' : 'USD'
}
</script>
